import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

const AvatarStack = ({ attendees = [], max = 5, size = "sm", onAvatarClick }) => {
  const displayAttendees = attendees.slice(0, max);
  const remaining = attendees.length - max;
  
  const sizeClasses = {
    xs: "w-6 h-6 text-[10px]",
    sm: "w-8 h-8 text-xs",
    md: "w-10 h-10 text-sm",
    lg: "w-12 h-12 text-base"
  };
  
  const getInitials = (name) => {
    if (!name) return "?";
    return name.split(" ").map(n => n[0]).join("").toUpperCase().slice(0, 2);
  };

  if (attendees.length === 0) {
    return null;
  }

  return (
    <div className="flex items-center">
      <div className="flex -space-x-2">
        {displayAttendees.map((attendee, index) => (
          <button
            key={attendee.user_id || index}
            onClick={() => onAvatarClick && attendee.user_id && onAvatarClick(attendee.user_id)}
            className={`rounded-full ${onAvatarClick ? 'hover:ring-2 hover:ring-primary/50 transition-all' : ''}`}
            style={{ zIndex: displayAttendees.length - index }}
            disabled={!onAvatarClick || !attendee.user_id}
          >
            <Avatar 
              className={`${sizeClasses[size]} border-2 border-background ring-0`}
            >
              <AvatarImage src={attendee.picture} alt={attendee.name} />
              <AvatarFallback className="bg-foreground/10 text-foreground font-medium">
                {getInitials(attendee.name)}
              </AvatarFallback>
            </Avatar>
          </button>
        ))}
        {remaining > 0 && (
          <div 
            className={`${sizeClasses[size]} rounded-full bg-muted border-2 border-background flex items-center justify-center font-medium text-muted-foreground`}
            style={{ zIndex: 0 }}
          >
            +{remaining}
          </div>
        )}
      </div>
    </div>
  );
};

export default AvatarStack;
